import { RestUrl } from "@/commons/constants/RestUrl";
import UrlFormatter from "@/commons/utils/UrlFormatter";
import CommonService from "@/commons/services/CommonService";
import LoginUser from "@/store/LoginUser";
import { HitomeqErrorType } from "@/commons/models/SystemError";

/**
 * ### 安否確認(家族)利用者状況 API 操作クラス
 */
export default class SafetyConfirmResidentStatuses {
  /** 共通サービス */
  private commonService: CommonService;

  /**
   * ### コンストラクター
   *
   * - 共通サービスが渡されればそれを使用する
   * - 共通サービスが渡されなければ新しいインスタンスを作る
   *
   * @param commonService 共通サービス
   */
  constructor(commonService?: CommonService) {
    this.commonService = commonService ? commonService : new CommonService();
    return;
  }

  /**
   * ### GET SafetyConfirmResidentStatus
   */
  public async gets(userStore: LoginUser, safetyConfirmsId: number): Promise<Array<SafetyConfirmResidentStatusGetModel>> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmResidentStatuses, formatParams);

    const response = await this.commonService.executeGet<Array<SafetyConfirmResidentStatusGetModel>>(
      userStore,
      requestUrl,
      this.constructor.name,
      null,
      HitomeqErrorType.REQUEST_RETRY,
      0
    );

    return response.data;
  }

  /**
   * ### POST SafetyConfirmResidentStatus
   */
  public async post(userStore: LoginUser, safetyConfirmsId: number, residentId: number, familyId: number, requestBody: SafetyConfirmResidentStatusPostModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmResidentStatus, formatParams);

    const response = await this.commonService.executePost<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }

  /**
   * ### PATCH SafetyConfirmResidentStatus
   */
  public async patch(userStore: LoginUser, safetyConfirmsId: number, residentId: number, familyId: number, requestBody: SafetyConfirmResidentStatusPatchModel): Promise<any> {
    const formatParams: any = {
      facilityId: userStore.loginUser.facilityId,
      safetyConfirmsId: safetyConfirmsId,
      residentId: residentId,
      familyId: familyId
    };
    const requestUrl: string = UrlFormatter.format(RestUrl.SafetyConfirmResidentStatus, formatParams);

    const response = await this.commonService.executePatch<any>(userStore, requestUrl, requestBody, this.constructor.name, HitomeqErrorType.REQUEST_RETRY, 0);

    return response.data;
  }
}

export interface SafetyConfirmResidentStatusGetModel {
  /** 施設ID */
  facilityId: number;
  /** ソートキー {safetyConfirmId}_{residentId}_{familyId} */
  safetyConfirmResidentStatusesSortKey: string;
  /** 災害ID */
  safetyConfirmsId: number;
  /** 利用者ID */
  residentId: number;
  /** 家族ID */
  familyId: number;
  /** 入力した施設状況 */
  statuses: Array<SafetyConfirmResidentStatusContents>;
  /** 削除フラグ */
  deleteFlag: boolean;
  /** レコード作成日 */
  created: number;
  /** レコード更新日 */
  updated: number;
}

export interface SafetyConfirmResidentStatusContents {
  /** 回答元のID。familySafetyConfirmMastersのIDにひもづく */
  id: number;
  /** 回答内容 */
  answer: string;
}

export interface SafetyConfirmResidentStatusPostModel {
  /** 入力した利用者状況 */
  statuses: Array<SafetyConfirmResidentStatusContents>;
}

export interface SafetyConfirmResidentStatusPatchModel {
  /** 入力した利用者状況 */
  statuses: Array<SafetyConfirmResidentStatusContents>;
  /** レコード更新日 */
  updated: number;
}
